module.exports = __webpack_public_path__ + "static/media/test2.3af11221.jpeg";